/** Approved migration review sizes apply to the available document pane, not the window. */
export const artifactReview = {
  tablePaneMin: 760,
  objectBrowserPaneMin: 960,
  editableTablePaneMin: 960,
  objectRailWidth: 240,
  navigationMaxHeight: 240,
  controlMinSize: 32,
} as const
